module.exports = __webpack_public_path__ + "static/media/1004912.7c65de48.png";